// 翻译语言映射
const languageTranslations = {
  "ZH": "cn",
  "GR": "el",
  "SE": "sv",
  "DK": "da",
  "KZ": "kk",
  "EE": "et",
  "IR": "sv",
  "LR": "fa",
  "IL": "da",
  "CZ": "cs",
  "KR": "ko",
  "UA": "uk",
  "CR": "hr",
}

// 转换
export const convert = (lang) => {
  const target = languageTranslations[lang];
  if(target) return target;
  return lang ? lang.toLowerCase() : lang;
}
